import React from 'react'
import { Icon, MenuItem } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  customHoverFocus: {
    '&:hover, &.Mui-focusVisible': { color: theme.palette.primary.main },
  },
}))
type Props = {
  label: string,
  iconName: string,
  onClick: () => void,
  disabled?: boolean,
}

export default function MatxMenuItem({ iconName, label, onClick, disabled }: Props) {
  const classes = useStyles()

  return (
    <div onClick={disabled ? undefined : onClick}>
      <MenuItem className={classes.customHoverFocus} disabled={disabled}>
        <Icon fontSize="small">{iconName}</Icon>
        <span className="pl-4">{label}</span>
      </MenuItem>
    </div>
  )
}
